export const SubscriptionStatusColor = {
  Pending_Activation: "#F3C118",
  Active: "#1e8700",
  Expired: "#CC0000",
  Cancelled: "#BDBDBD"
};

export default SubscriptionStatusColor;
